<template>
  <v-dialog
    v-bind="computedProps"
    v-on="computedListeners"
    v-model="showDialog">

    <v-card
      min-height="80%"
      min-width="80%">

      <v-toolbar
        elevation="2"
        color="#2F75B5"
        dark
        dense>

        <v-spacer/>

        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>

        <v-spacer/>

        <v-btn
          @click="onCloseClick"
          text>
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>

      <v-container
        fluid
        class="px-5 ma-0">

        <dd-sub-header>
          検索条件
        </dd-sub-header>
        <v-row>
          <v-col :cols="6">
            <dd-text-box
              label="キーワード"
              v-model="searchText"
              :length="100"
              :valueType="ctypes.InputTypes.Free"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="6">
            <dd-sub-header>
              一覧
              <!--
              <template v-if="(targetMaster)">
                <dd-icon-button-with-tooltip
                  @click="onAddMaster()"
                  icon="mdi-plus-box"
                  message="ここからマスタデータの新規登録が実行できます"
                  />
              </template>
              -->
            </dd-sub-header>
          </v-col>
          <v-col :cols="3"/>
          <v-col :cols="3">
            <dd-row-count-box
              v-model="rowCount"/>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col :cols="12">

            <dd-data-table
              height="50vh"
              item-key="torisakiCd"
              @click:row="onRowClick"
              :headers="headerList"
              :items="itemList"
              :search="searchText"
              :page.sync ="page"
            />

          </v-col>

        </v-row>

      </v-container>

      <v-footer color="#FFFFFF">
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer/>
      </v-footer>

    </v-card>
  </v-dialog>
</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
// import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdFooterButton from '@/components/DdFooterButton'
import DdTextBox from '@/components/DdTextBox'
import DdDataTable from '@/components/DdDataTable'
import DdRowCountBox from '@/components/DdRowCountBox'

import controls from '@/rahmen/controls'

/**
 * @file DDv2用マスタ検索用ダイアログ
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [showDialog=false] - ダイアログ表示可否
 * @vue-prop {Array} headerList - ダイアログ用ヘッダリスト
 * @vue-prop {Array} itemList - オートコンプリート用リスト
 * @vue-prop {String} titleText - ダイアログ用表示タイトル
 * @see DdCodeTextBox
 * @example
    <dd-master-search-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerList="headerList"
      :itemList="itemList"
      [atmark]close="onDialogClosed"/>
 */
export default {
  name: 'DdMasterSearchDialog',
  components: {
    DdSubHeader,
    // DdIconButtonWithTooltip,
    DdFooterButton,
    DdTextBox,
    DdDataTable,
    DdRowCountBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 一覧内容
     */
    itemList: Array,
    /**
     * ヘッダー設定
     */
    headerList: Array,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * 対象マスタ
     */
    targetMaster: String
  },
  data: () => ({
    title: '',
    searchText: '',
    ctypes: controls,
    page: 1
  }),
  created () {
  },
  mounted () {
    this.title = this.titleText
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    rowCount () {
      return this.itemList.length
    }
  },
  methods: {
    onRowClick: function (e) {
      /**
       * 選択時クローズ処理
       * @event close
       * @type {Event}
       */
      this.$emit('close', e)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event close
       * @type {Event}
       */
      this.$emit('close', undefined)
    },
    onAddMaster: function () {
      var path = location.href
      path = path.substring(0, path.indexOf('#/'))
      var url = path + '#/mst/' + this.targetMaster + '/edit/0'
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 600 !important;
}
</style>
